import { throttle } from 'lodash';
import { useEffect } from 'react';
import { useDispatch } from '@shared/store';

export function useDispatchViewportDimensions() {
  const dispatch = useDispatch();
  useEffect(() => {
    function onResize() {
      dispatch({
        type: 'VIEWPORT_DIMENSION_CHANGE',
        value: {
          viewportHeight: window.innerHeight,
          viewportWidth: window.innerWidth,
        },
      });
    }

    onResize();

    const throttledOnResize = throttle(onResize, 100);
    window.addEventListener('resize', throttledOnResize);
    return () => window.removeEventListener('resize', throttledOnResize);
  }, [dispatch]);
}
